import React, { createContext, useContext, useState, useCallback } from "react";
import "./Toaster.css";

const ToasterContext = createContext(null);

let toastId = 0;

export function ToasterProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, type = "info", duration = 4000) => {
    const id = ++toastId;
    setToasts((prev) => [...prev, { id, message, type }]);

    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, duration);

    return id;
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const toastSuccess = useCallback(
    (message) => addToast(message, "success"),
    [addToast]
  );

  const toastError = useCallback(
    (message) => addToast(message, "error"),
    [addToast]
  );

  const toastWarning = useCallback(
    (message) => addToast(message, "warning"),
    [addToast]
  );

  const toastInfo = useCallback(
    (message) => addToast(message, "info"),
    [addToast]
  );

  const value = {
    toastSuccess,
    toastError,
    toastWarning,
    toastInfo,
    removeToast,
  };

  return (
    <ToasterContext.Provider value={value}>
      {children}
      <div className="toaster-container">
        {toasts.map((toast) => (
          <div
            key={toast.id}
            className={`toast toast-${toast.type}`}
            onClick={() => removeToast(toast.id)}
          >
            <span className="toast-message">{toast.message}</span>
            <button className="toast-close" onClick={() => removeToast(toast.id)}>
              &times;
            </button>
          </div>
        ))}
      </div>
    </ToasterContext.Provider>
  );
}

export function useToaster() {
  const context = useContext(ToasterContext);
  if (!context) {
    throw new Error("useToaster must be used within a ToasterProvider");
  }
  return context;
}
